// extracted by mini-css-extract-plugin
module.exports = {"headline":"FaqArticle_headline__XS4wN"};